import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {DatePicker} from "antd"
import moment from "moment"

const {RangePicker} = DatePicker

StaticOverviewFilters.propTypes = {
    selectedDate: PropTypes.any,
    onChangeName: PropTypes.func.isRequired,
    onChangeDateFilter: PropTypes.func.isRequired,
    onChangeSelectedDate: PropTypes.func.isRequired
}

function StaticOverviewFilters(props) {
    const {onChangeName, onChangeSelectedDate, selectedDate, onChangeDateFilter} = props
    const [user, setUser] = useState('')

    const _handleChangeInput = (e) => {
        const {value} = e.target

        setUser(value)

        if (typeof onChangeName === 'function') {
            onChangeName(value)
        }
    }

    const _onChange = (dates) => {
        if (!!dates && dates.length === 2) {
            const from = moment(dates[0]).format('DD/MM/YYYY HH:mm:ss')
            const to = moment(dates[1]).format('DD/MM/YYYY HH:mm:ss')

            if (typeof onChangeDateFilter === 'function') {
                onChangeDateFilter({
                    from,
                    to,
                })
            }

            if (typeof onChangeSelectedDate === 'function') {
                onChangeSelectedDate(dates)
            }
        } else {
            if (typeof onChangeDateFilter === 'function') {
                onChangeDateFilter(null)
            }
            if (typeof onChangeSelectedDate === 'function') {
                onChangeSelectedDate([])
            }
        }
    }

    return (
        <div className='StaticOverviewFilters'>
            <div className="Search">
                <label htmlFor="name">Username</label>
                <input type="text" value={user} onChange={_handleChangeInput} placeholder="Input username..."/>
            </div>
            <div className="Filter">
                <span className="Label">Thời gian</span>
                <div className='DatePicker'>
                    <RangePicker
                        value={selectedDate}
                        showTime={{format: 'HH:mm'}}
                        format="HH:mm - DD/MM/YYYY"
                        onChange={_onChange}
                    />
                </div>
            </div>
        </div>
    )
}

export default StaticOverviewFilters
